/** Délai maximal d'un appel réseau (Supabase) : au-delà, l'appel est traité comme un échec réseau. */
export const NET_TIMEOUT_MS = 8000;

/** Erreur levée quand un appel dépasse son délai. */
export class TimeoutError extends Error {
  constructor(label: string, ms: number) {
    super(`Délai dépassé (${ms} ms) : ${label}`);
    this.name = 'TimeoutError';
  }
}

/** Résout comme `p`, ou rejette avec une `TimeoutError` si `p` n'est pas réglée au bout de `ms` millisecondes (le minuteur est toujours libéré). */
export function withTimeout<T>(p: Promise<T>, ms: number, label: string): Promise<T> {
  return new Promise<T>((resolve, reject: (reason?: unknown) => void) => {
    const timer = setTimeout(() => reject(new TimeoutError(label, ms)), ms);
    p.then(
      (v) => { clearTimeout(timer); resolve(v); },
      // le rejet est propagé tel quel (une erreur Supabase garde son `code`)
      (e: unknown) => { clearTimeout(timer); reject(e); },
    );
  });
}
